<script setup>
import MonitorHeader from "../MonitorHeader.vue";
import {useMonitorStore} from "../../../store/monitoring.js";
import {reactive, onMounted, onUnmounted} from "vue";

const store = useMonitorStore()
const stats = reactive({
    orders: null,
    today_orders: null,
    this_month_orders: null,
    open_chats: null,
    calls: null,
    new_client_calls: null,
    current_client_calls: null
})

const getStats = async () => {
    await store.getHomeStats()
    if (store.home_stats) {
        stats.orders = store.home_stats['orders']
        stats.today_orders = store.home_stats['today_orders']
        stats.this_month_orders = store.home_stats['this_month_orders']
        stats.open_chats = store.home_stats['open_chats']
        stats.calls = store.home_stats['calls']
        stats.new_client_calls = store.home_stats['new_client_calls']
        stats.current_client_calls = store.home_stats['current_client_calls']
    }
}

onMounted(async () => {
    await getStats()

    window.Echo.private(`chats`)
        .listen('ChatCreated', async (e) => {
            await getStats()
        })
        .listen('ChatCompleted', async (e) => {
            await getStats()
        })

    window.Echo.private(`orders`)
        .listen('OrderCreated', async (e) => {
            await getStats()
        })

    window.Echo.private(`calls`)
        .listen('OutboundCallCreated', async (e) => {
            await getStats()
        })
        .listen('OutboundCallCompleted', async (e) => {
            await getStats()
        })
})

onUnmounted(() => {
    window.Echo.leave(`private-chats`)
    window.Echo.leave(`private-orders`)
    window.Echo.leave(`private-calls`)
})
</script>

<template>
    <div class="monitor-container">
        <monitor-header title="Reseller team."/>

        <div class="monitor-overview-container">
            <div class="monitor-overview-item">
                <div class="monitor-pill">
                    <div class="monitor-pill-content">
                        <div class="monitor-pill-icon-block">
                            <ah-icon name="cart-default"/>
                        </div>
                        <div class="monitor-pill-info">
                            <p class="monitor-pill-title">All orders.</p>
                            <p class="monitor-pill-stat">{{ stats.orders }}</p>
                        </div>
                    </div>
                </div>

                <div class="monitor-pill --is-today">
                    <div class="monitor-pill-content">
                        <div class="monitor-pill-icon-block">
                            <ah-icon name="calendar-empty"/>
                        </div>
                        <div class="monitor-pill-info">
                            <p class="monitor-pill-title">Today.</p>
                            <p class="monitor-pill-stat">{{ stats.today_orders }}</p>
                        </div>
                    </div>
                </div>

                <div class="monitor-pill">
                    <div class="monitor-pill-content">
                        <div class="monitor-pill-icon-block">
                            <ah-icon name="calendar-range"/>
                        </div>
                        <div class="monitor-pill-info">
                            <p class="monitor-pill-title">This month.</p>
                            <p class="monitor-pill-stat">{{ stats.this_month_orders }}</p>
                        </div>
                    </div>
                </div>
            </div>


            <div class="monitor-overview-item">
                <div class="monitor-pill" :class="{'--is-danger':stats.open_chats > 3000}">
                    <div class="monitor-pill-content">
                        <div class="monitor-pill-icon-block">
                            <ah-icon name="speechbubble-double"/>
                        </div>
                        <div class="monitor-pill-info">
                            <p class="monitor-pill-title">Open chats.</p>
                            <p class="monitor-pill-stat">{{ stats.open_chats }}</p>
                        </div>
                    </div>
                </div>


                <div class="monitor-pill --has-sub">
                    <div class="monitor-pill-content">
                        <div class="monitor-pill-icon-block">
                            <ah-icon name="call-default"/>
                        </div>
                        <div class="monitor-pill-info">
                            <p class="monitor-pill-title">Upcoming calls.</p>
                            <p class="monitor-pill-stat">{{ stats.calls }}</p>
                        </div>
                    </div>

                    <div class="monitor-pill-sub">
                        <div class="monitor-pill-sub-item">
                            <p class="monitor-pill-sub-item-title">New clients.</p>
                            <p class="monitor-pill-sub-item-value">{{ stats.new_client_calls }}</p>
                        </div>
                        <div class="monitor-pill-sub-item">
                            <p class="monitor-pill-sub-item-title">Current clients.</p>
                            <p class="monitor-pill-sub-item-value">{{ stats.current_client_calls }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
